var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 76,
    viewBox: "0 0 310 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 308.654,
    height: 75,
    transform: "translate(0.673096 0.5)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9808 19.1859H25.2377V50.3305H43.0777V57.2852H17.9808V19.1859Z",
    fill: "#25293F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3348 19.1859H57.5918V57.2852H50.3348V19.1859Z",
    fill: "#25293F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8724 19.1859H74.2225L91.1551 43.9806V19.1859H98.4122V57.2852H92.0624L75.1294 32.4903V57.2852H67.8724V19.1859Z",
    fill: "#25293F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.657 41.2593L133.89 45.1903C134.193 44.646 134.495 44.0412 134.798 43.3155C135.221 42.106 135.705 40.3522 135.705 38.2357C135.705 30.9785 130.564 25.8382 124.517 25.8382C118.469 25.8382 113.329 30.9785 113.329 38.2357C113.329 45.4927 118.469 50.633 124.517 50.633C126.15 50.633 127.42 50.3306 128.327 50.0282C128.81 49.8469 129.234 49.6654 129.657 49.4234L125.726 45.4927L129.657 41.2593ZM134.798 54.2615C134.011 54.9267 133.044 55.4711 132.016 55.9548C130.262 56.8619 127.662 57.5875 124.517 57.5875C114.539 57.5875 106.072 49.121 106.072 38.2357C106.072 27.3501 114.539 18.8836 124.517 18.8836C134.495 18.8836 142.962 27.3501 142.962 38.2357C142.962 41.8641 141.934 44.8879 140.966 47.0046C140.422 48.2743 139.757 49.363 139.031 50.3306L142.659 53.9592L138.729 58.1923L134.798 54.2615Z",
    fill: "#25293F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M210.594 42.7713L205.756 28.8619L200.917 42.7713H210.594ZM202.43 19.1859H209.082L223.293 57.2852H215.734L213.013 49.4235H198.499L195.777 57.2852H188.218L202.43 19.1859Z",
    fill: "#25293F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M227.828 19.1855H235.086V42.7626C235.086 46.9773 238.403 50.5099 242.616 50.6278C247.647 50.7686 250.809 47.7184 250.809 42.7709V19.1855H258.066V42.7709C258.066 51.2372 251.716 57.5872 242.947 57.5872C234.178 57.5872 227.828 51.2372 227.828 42.7709V19.1855Z",
    fill: "#25293F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M268.044 19.1859H275.301V50.3305H293.141V57.2852H268.044V19.1859Z",
    fill: "#25293F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M158.568 58.1418V42.1543C158.568 37.859 162.008 34.3272 166.303 34.2737C168.636 34.2448 170.816 34.9885 172.194 36.2148V28.3037C170.453 27.6608 168.506 27.3007 166.449 27.3007C157.658 27.3007 151.292 33.6666 151.292 42.1543V58.1418H158.568Z",
    fill: "#00FFF1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M174.588 17.8417V33.8293C174.588 38.1245 171.147 41.6563 166.852 41.7098C164.52 41.7387 162.599 41.0737 161.222 39.8474L160.986 47.6881C162.727 48.3312 164.649 48.6828 166.707 48.6828C175.497 48.6828 181.863 42.3169 181.863 33.8293V17.8417H174.588Z",
    fill: "#00FFF1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M151.292 32.9938C151.292 32.9938 152.634 28.5969 158.568 26.5452V17.8077H151.292V32.9938Z",
    fill: "#00FFF1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M182.243 42.2037C182.243 42.2037 180.902 46.6007 174.968 48.6523V58.1011H182.243V42.2037Z",
    fill: "#00FFF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/LoginLogo.2b1d6b0b0950f328127101b86ef157be.svg";
export { ForwardRef as ReactComponent };